import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/illustration-behavior-dog.svg';

export const BehavioralExposuresStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const descriptions: string[] = t('week-7.behavioral-exposures.descriptions', {
        returnObjects: true,
    });

    const exposures: string[] = t('week-7.behavioral-exposures.exposures', {
        returnObjects: true,
    });

    return (
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepHeading>{t('week-7.behavioral-exposures.title')}</S.StepHeading>
                {descriptions.map(description => (
                    <S.StepDescription small key={description}>
                        {description}
                    </S.StepDescription>
                ))}
                <S.StyledOrderedList>
                    {exposures.map(exposure => (
                        <S.StyledOrderedListElement key={exposure}>
                            {exposure}
                        </S.StyledOrderedListElement>
                    ))}
                </S.StyledOrderedList>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon large iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    );
});
